export const cashierTranslations = {
    ar: {
        items: {
            color: 'اللون',
            selectColor: 'اختر لون',
        },
        tabs: {
            order: 'طلب',
            new: 'علامة تبويب جديدة',
            close: 'إغلاق علامة التبويب'
        },
        orderDetails: {
            title: 'تفاصيل الطلب',
            type: 'نوع الطلب',
            pickup: 'استلام',
            delivery: 'توصيل',
            table: 'خدمة الطاولة',
            searchCustomer: 'بحث عن عميل',
            searchPlaceholder: 'البحث بالاسم أو رقم الهاتف',
            newCustomer: 'عميل جديد',
            tableNumber: 'رقم الطاولة',
            buttons: {
                submit: 'تأكيد',
                cancel: 'إلغاء'
            },
            customerName: 'اسم العميل',
            customerPhone: 'رقم الهاتف',
            deliveryAddress: 'عنوان التوصيل',
            deliveryFee: 'رسوم التوصيل',
            minOrderError: 'الحد الأدنى للطلب للتوصيل هو {{amount}}',
            loadingCustomers: 'جاري تحميل العملاء...',
            noCustomersFound: 'لم يتم العثور على عملاء'
        },
        errors: {
            loadingCustomers: 'خطأ في تحميل العملاء',
            selectCustomer: 'الرجاء اختيار عميل',
            enterTableNumber: 'الرجاء إدخال رقم الطاولة'
        },
        payment: {
            select_payment_method: 'اختر طريقة الدفع',
            cash: 'نقداً',
            card: 'بطاقة',
            confirm: 'تأكيد',
            cancel: 'إلغاء',
            errors: {
                create_order: 'فشل في إنشاء الطلب'
            },
            title: 'الدفع',
            method: 'طريقة الدفع',
            methods: {
                cash: 'نقدي',
                card: 'بطاقة'
            },
            actions: {
                process: 'إتمام الدفع',
                processing: 'جاري المعالجة...',
                cancel: 'إلغاء'
            },
            messages: {
                success: 'تم الدفع بنجاح',
                error: 'حدث خطأ أثناء الدفع'
            },
            select: 'اختر طريقة الدفع',
            totalAmount: 'المبلغ الإجمالي',
            customerType: 'نوع العميل',
            regularCustomer: 'عميل عادي',
            companyCustomer: 'شركة',
            companyName: 'اسم الشركة',
            enterCompanyName: 'أدخل اسم الشركة',
            taxNumber: 'الرقم الضريبي',
            enterTaxNumber: 'أدخل الرقم الضريبي',
            invalidTaxNumber: 'يجب أن يتكون الرقم الضريبي من 15 رقمًا',
            checkout: 'إتمام الدفع'
        },
        customer: {
            register: {
                title: 'تسجيل عميل جديد',
                submit: 'تسجيل',
                cancel: 'إلغاء',
                success: 'تم تسجيل العميل بنجاح',
                error: 'خطأ في تسجيل العميل'
            },
            form: {
                name: {
                    label: 'الاسم',
                    placeholder: 'أدخل اسم العميل',
                    required: 'الرجاء إدخال اسم العميل'
                },
                phone: {
                    label: 'رقم الهاتف',
                    placeholder: 'أدخل رقم الهاتف',
                    required: 'الرجاء إدخال رقم الهاتف'
                },
                address: {
                    label: 'العنوان',
                    placeholder: 'أدخل العنوان',
                    required: 'الرجاء إدخال العنوان'
                },
                notes: {
                    label: 'ملاحظات',
                    placeholder: 'أدخل ملاحظات إضافية (اختياري)'
                }
            }
        },
        cart: {
            title: 'سلة المشتريات',
            empty: 'السلة فارغة',
            subtotal: 'الإجمالي قبل الضريبة',
            tax: 'الضريبة',
            total: 'الإجمالي شامل الضريبة',
            checkout: 'إتمام الطلب',
            clear: 'إفراغ السلة',
            remove: 'إزالة',
            remove_item: 'إزالة المنتج',
            quantity: 'الكمية',
            price: 'السعر',
            editQuantity: 'تعديل الكمية',
            editPrice: 'تعديل السعر'
        },
        subtotal: 'الإجمالي قبل الضريبة',
        total: 'الإجمالي شامل الضريبة',
        receipt: {
            phone: 'للحجز والتواصل',
            header: 'فاتورة المبيعات',
            simplifiedTaxInvoice: 'فاتورة ضريبية مبسطة',
            taxInvoice: 'فاتورة ضريبية',
            taxNumber: 'الرقم الضريبي',
            orderNumber: 'رقم الطلب',
            tableNumber: 'رقم الطاولة',
            footer: 'شكراً لزيارتكم!',
            date: 'التاريخ',
            returnReceipt: 'إشعار إرجاع',
            returnedItems: 'منتجات مرتجعة',
            item: 'الصنف',
            qty: 'الكمية',
            price: 'السعر',
            total: 'المجموع',
            time: 'الوقت',
            orderType: 'نوع الطلب',
            paymentMethod: 'طريقة الدفع',
            items: {
                name: 'الصنف',
                quantity: 'الكمية',
                price: 'السعر',
                total: 'المجموع'
            },
            totals: {
                subtotal: 'الإجمالي قبل الضريبة',
                tax: 'الضريبة',
                deliveryFee: 'رسوم التوصيل',
                serviceCharge: 'رسوم الخدمة',
                total: 'الإجمالي شامل الضريبة'
            },
            delivery: {
                title: 'معلومات التوصيل',
                customerName: 'العميل',
                customerPhone: 'الهاتف',
                deliveryAddress: 'العنوان'
            }
        },
        messages: {
            orderSuccess: 'تم إكمال الطلب بنجاح',
            orderError: 'فشل في معالجة الطلب',
            printError: 'فشل في فتح نافذة الطباعة'
        }
    },
    en: {
        items: {
            color: 'Color',
            selectColor: 'Select a color',
        },
        tabs: {
            order: 'Order',
            new: 'New Tab',
            close: 'Close Tab'
        },
        orderDetails: {
            buttons: {
                submit: 'Submit',
                cancel: 'Cancel'
            },
            title: 'Order Details',
            type: 'Order Type',
            pickup: 'Pickup',
            delivery: 'Delivery',
            table: 'Table Service',
            searchCustomer: 'Search Customer',
            searchPlaceholder: 'Search by name or phone',
            newCustomer: 'New Customer',
            tableNumber: 'Table Number',
            customerName: 'Customer Name',
            customerPhone: 'Phone Number',
            deliveryAddress: 'Delivery Address',
            deliveryFee: 'Delivery Fee',
            minOrderError: 'Minimum order amount for delivery is {{amount}}',
            loadingCustomers: 'Loading customers...',
            noCustomersFound: 'No customers found'
        },
        errors: {
            loadingCustomers: 'Error loading customers',
            selectCustomer: 'Please select a customer',
            enterTableNumber: 'Please enter table number'
        },
        payment: {
            select_payment_method: 'Select Payment Method',
            cash: 'Cash',
            card: 'Card',
            confirm: 'Confirm',
            cancel: 'Cancel',
            errors: {
                create_order: 'Failed to create order'
            },
            title: 'Payment',
            method: 'Payment Method',
            methods: {
                cash: 'Cash',
                card: 'Card'
            },
            actions: {
                process: 'Process Payment',
                processing: 'Processing...',
                cancel: 'Cancel'
            },
            messages: {
                success: 'Payment successful',
                error: 'Payment failed'
            },
            receipt: {
                phone: 'For Reservations',
                header: 'Sales Invoice',
                simplifiedTaxInvoice: 'Simplified Tax Invoice',
                taxNumber: 'Tax Number',
                orderNumber: 'Order #',
                date: 'Date',
            },
            select: 'Select Payment Method',
            totalAmount: 'Total Amount',
            customerType: 'Customer Type',
            regularCustomer: 'Regular Customer',
            companyCustomer: 'Company',
            companyName: 'Company Name',
            enterCompanyName: 'Enter company name',
            taxNumber: 'Tax Number',
            enterTaxNumber: 'Enter tax number',
            invalidTaxNumber: 'Tax number must be 15 digits',
            checkout: 'Complete Checkout'
        },
        customer: {
            register: {
                title: 'Register New Customer',
                submit: 'Register',
                cancel: 'Cancel',
                success: 'Customer registered successfully',
                error: 'Error registering customer'
            },
            form: {
                name: {
                    label: 'Name',
                    placeholder: 'Enter customer name',
                    required: 'Please input customer name'
                },
                phone: {
                    label: 'Phone Number',
                    placeholder: 'Enter phone number',
                    required: 'Please input phone number'
                },
                address: {
                    label: 'Address',
                    placeholder: 'Enter address',
                    required: 'Please input address'
                },
                notes: {
                    label: 'Notes',
                    placeholder: 'Enter additional notes (optional)'
                }
            }
        },
        cart: {
            title: 'Shopping Cart',
            empty: 'Cart is empty',
            subtotal: 'Subtotal',
            tax: 'Tax',
            total: 'Total',
            checkout: 'Checkout',
            clear: 'Clear Cart',
            remove: 'Remove',
            remove_item: 'Remove item',
            quantity: 'Quantity',
            price: 'Price',
            editQuantity: 'Edit Quantity',
            editPrice: 'Edit Price'
        },
        subtotal: 'Subtotal',
        total: 'Total',
        receipt: {
            phoneNumber: 'Phone Number',
            header: 'Sales Receipt',
            simplifiedTaxInvoice: 'Simplified Tax Invoice',
            taxInvoice: 'Tax Invoice',
            taxNumber: 'Tax Number',
            orderNumber: 'Order Number',
            returnReceipt: 'Return Notice',
            returnedItems: 'Returned Items',
            item: 'Item',
            qty: 'Qty',
            price: 'Price',
            total: 'Total',
            tableNumber: 'Table Number',
            serviceCharge: 'Service Charge',
            deliveryFee: 'Delivery Fee',
            footer: 'Thank you for your visit!',
            date: 'Date',
            time: 'Time',
            paymentMethod: 'Payment Method',
            items: {
                name: 'Item',
                quantity: 'Qty',
                price: 'Price',
                total: 'Total'
            },
            totals: {
                subtotal: 'Subtotal',
                tax: 'Tax',
                deliveryFee: 'Delivery Fee',
                serviceCharge: 'Service Charge',
                total: 'Total'
            },
            delivery: {
                title: 'Delivery Information',
                customerName: 'Customer',
                customerPhone: 'Phone',
                deliveryAddress: 'Address'
            }
        },
        messages: {
            orderSuccess: 'Order completed successfully',
            orderError: 'Failed to process order',
            printError: 'Failed to open print window'
        }
    }
};
